import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { actions } from '../../InventoryState'
import TableMui from 'src/components/TableMui'
import { selectBadges } from '../../InventorySelector'
import * as S from './ManageBadges.styles'
import ModalDeleteBadge from '../ModalDeleteBadge'
import { handleOnKeyDown } from 'src/utils/Form'

interface Props {
  setClickBadges: (value: boolean) => void
}

export const ManageBadges = ({
  setClickBadges,
}: Props) => {
  const [openModalDeleteBadge, setOpenModalDeleteBadge] = useState(false)
  const [badgeToDelete, setBadgeToDelete] = useState()
  const badges = useSelector(selectBadges)

  const {
    register, getValues, watch, reset, trigger, clearErrors, setError, formState: { errors },
  } = useForm()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.getBadges())
  }, [dispatch])

  const validateAndAddBadge = async () => {
    const validationSuccess = await trigger('badgeInventory')

    const onSuccess = async () => {
      clearErrors('badgeInventory')
      reset({ badgeInventory: '' })
    }

    if (validationSuccess) {
      dispatch(
        actions.validateAndAddBadge({
          badge: getValues('badgeInventory'),
          onSuccess,
          setError: (message) => setError('badgeInventory', { message }),
        }),
      )
    }
  }

  const onClickDelete = (item) => {
    setBadgeToDelete(item)
    setOpenModalDeleteBadge(true)
  }

  const tableRows = badges?.map((b) => ({
    ...b,
    deleteBadge: <S.RemoveBatchButton size={20} data-testid='delete-badge-button-test' onClick={() => onClickDelete(b.userBadge)} />,
  }))

  return (
    <S.FilterContainer>
      <S.CustomContainerTextArea>
        <S.CustomTextFieldBadge
          inputProps={{
            ...register('badgeInventory', { required: 'Campo obrigatório' }),
            'data-testid': 'add-badge-input-test',
          }}
          id='badgeInventory'
          name='badgeInventory'
          error={!!errors.badgeInventory}
          label='badges.inventory'
          helperText={errors.badgeInventory?.message}
          type='text'
          autoComplete='off'
          fullWidth
          onKeyDown={(e) => handleOnKeyDown(e, '', validateAndAddBadge)}
        />
        <S.CustomButtonBadge
          title='Adicionar Crachá'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          onClick={validateAndAddBadge}
          disabled={watch('badgeInventory') === ''}
          data-testid='add-badge-button-test'
        />
        <TableMui
          columns={[
            { id: 'userName', label: 'Nome' },
            { id: 'deleteBadge', label: 'Deletar' },
          ]}
          emptyLabel='Nenhum crachá para mostrar'
          rows={tableRows}
          enablePagination
          rowsPerPageLimit={10}
        />
      </S.CustomContainerTextArea>
      <S.CustomButton
        title='Voltar'
        bgColor='blue'
        hoverColor='darkBlueHover'
        letterColor='white'
        onClick={() => setClickBadges(false)}
        data-testid='back-button-badge-test'
      />
      <ModalDeleteBadge
        open={openModalDeleteBadge}
        setOpen={setOpenModalDeleteBadge}
        badgeToDelete={badgeToDelete}
      />
    </S.FilterContainer>
  )
}
